import l from "react";
import p from "./userInitials.module.scss.js";
function u({
  children: t,
  fullName: i,
  size: e,
  backgroundColor: s = "#000",
  textColor: o = "#FFF"
}) {
  const a = i.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase() ?? "", r = Math.round(e * (22 / 50));
  return /* @__PURE__ */ l.createElement(
    "div",
    {
      "data-testid": "user-initials",
      className: p.UserInitials,
      style: {
        "--size": `${e}px`,
        "--backgroundColor": s,
        "--textColor": o,
        fontSize: r
      }
    },
    !t && a,
    t
  );
}
export {
  u as UserInitials
};
//# sourceMappingURL=UserInitials.js.map
